import { gql } from '@apollo/client';

export const removeFromWishlist = gql`
  mutation RemoveFromWishlist($sku: String!, $locale: Locale!) {
    wishlist: removeArticleFromWishlist(sku: $sku) {
      name
      articles(locale: $locale) {
        sku
      }
    }
  }
`;
